import React, { FunctionComponent } from 'react';

import { ImagePicker, ImagePickerProps } from '@yandex-360/orb-components/dist/components/ImagePicker';
import { ImagePickerItemProps } from '@yandex-360/orb-components/dist/components/ImagePicker/ImagePickerItem';
import { VirtualBackgroundType } from '@yandex-360/telemost-sdk/device-manager';
import { useSelector } from 'react-redux';

import { SvgImage } from '../../../../../../components';
import { PngImage } from '../../../../../../components/png-image';
import { countMetrika } from '../../../../../../helpers/metrika';
import { useActions } from '../../../../../../hooks';
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector';
import {
    getVideoFacingMode,
    getVideoInputDeviceSelector,
    selectVirtualBackgroundType,
    setVirtualBackgroundType as setVirtualBackgroundTypeAction,
} from '../../../../../settings';
import { isMobileUa } from '../../../../../uatraits';
import { Island } from '../../island';
import { VideoPreview } from '../../video-preview';
import css from './styles.css';

const IMAGE_ITEMS: ImagePickerItemProps[] = [
    {
        item: (
            <div className={css.imageItem}>
                <PngImage name="blurredV2" />
                <SvgImage className={css.releasePhaseIconWrapper} imageName="ndaV2" />
            </div>
        ),
        value: VirtualBackgroundType.BLURRED,
        testId: 'virtual-background-blurred',
    },
];

export const VirtualBackgroundSection: FunctionComponent = () => {
    const { setVirtualBackgroundType } = useActions({ setVirtualBackgroundType: setVirtualBackgroundTypeAction });

    const isMobile = useSelector(isMobileUa);
    const currentDeviceId = useTypedSelector((state) => getVideoInputDeviceSelector(state)?.deviceId);
    const facingMode = useSelector(getVideoFacingMode);

    const deviceIdOrFacingMode = isMobile ? facingMode : currentDeviceId;

    const virtualBackgroundType = useSelector(selectVirtualBackgroundType);

    const setSelectedItemType = (value: string) => {
        const type = value === 'no-image' ? VirtualBackgroundType.NONE : (value as VirtualBackgroundType);
        setVirtualBackgroundType(type);
        countMetrika('interface elements', 'settings popup', 'virtual background', type);
    };

    const pickerDefaultValue =
        virtualBackgroundType === VirtualBackgroundType.NONE ? 'no-image' : virtualBackgroundType;

    return (
        <Island className={css.virtualBackgroundWrapper}>
            <div className={css.preview}>
                <VideoPreview deviceIdOrFacingMode={deviceIdOrFacingMode} />
            </div>
            <div className={css.options}>
                <ImagePicker
                    groupHeight="var(--settings-v-2-virtual-background-image-picker-item-height)"
                    groupWidth="var(--settings-v-2-virtual-background-image-picker-item-width)"
                    defaultValue={pickerDefaultValue}
                    imageItems={IMAGE_ITEMS}
                    onChange={setSelectedItemType as ImagePickerProps['onChange']}
                />
            </div>
        </Island>
    );
};
